/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h2: "h2",
    code: "code",
    p: "p",
    a: "a",
    h3: "h3"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.h2, {
      children: ["How do I use styled-components with ", _jsx(_components.code, {
        children: "create-react-app"
      }), "?"]
    }), "\n", _jsx(_components.p, {
      children: "The basic functionality of the library should work out of the box like any other library."
    }), "\n", _jsxs(_components.p, {
      children: ["However, if you want to do server-side rendering or take advantage of some of the advanced capabilities of the ", _jsx(_components.a, {
        href: "/docs/tooling#babel-plugin",
        children: "styled-components babel plugin"
      }), " without ejecting you'll need to set up ", _jsx(_components.a, {
        href: "https://github.com/timarney/react-app-rewired",
        children: _jsx(_components.code, {
          children: "react-app-rewired"
        })
      }), " and ", _jsx(_components.a, {
        href: "https://github.com/withspectrum/react-app-rewire-styled-components",
        children: _jsx(_components.code, {
          children: "react-app-rewire-styled-components"
        })
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "Babel Macro"
    }), "\n", _jsxs(_components.p, {
      children: ["As of create-react-app v2, there is now an alternative to setting up ", _jsx(_components.code, {
        children: "react-app-rewired"
      }), " through use of \"babel macros\". See the ", _jsx(_components.a, {
        href: "/docs/tooling#babel-macro",
        children: "documentation for the styled-components babel macro"
      }), " for setup and usage."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
